import { BASE_URL } from "../../Constant";

export const API_GET_ALL_BOOKING_MESSAGES = BASE_URL + "/whatsapp/bookingMessages";
export const API_GET_BOOKING_MESSAGES_LOAD_ABOVE = BASE_URL + "/whatsapp/bookingMessages/loadAbove";
export const API_GET_BUSINESS_MESSAGE_COUNT = BASE_URL + "/whatsapp/businessMessages/count";
export const API_GET_BUSINESS_MESSAGES = BASE_URL + "/whatsapp/businessMessages";
export const WHATSAPP_BUSINESS_ID_QUERY_PARAM = "businessId";

export const BOOKING_MESSAGES_PAGE_LIMIT = 50;
export const BOOKING_MESSAGES_PREFETCH_THRESHOLD = 10;